import { render, staticRenderFns } from "./DashboardChangePlan.vue?vue&type=template&id=3272489e&scoped=true"
import script from "./DashboardChangePlan.vue?vue&type=script&lang=js"
export * from "./DashboardChangePlan.vue?vue&type=script&lang=js"
import style0 from "./DashboardChangePlan.vue?vue&type=style&index=0&id=3272489e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272489e",
  null
  
)

export default component.exports